var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer6 = function SvgNumTimer6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M4.936 29q-3.312 0-3.312-3.336V10.856q0-3.336 3.312-3.336h13.152v3.888H6.232v3.84h8.928q1.704 0 2.472.768.792.768.792 2.496v7.152q0 3.336-3.336 3.336zm8.88-3.888v-6.048H6.232v6.048z"
  })));
};
export default SvgNumTimer6;